module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-207.7aa20b15.svg";